<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="frontmatter Other exclude-auto page-open-auto" id="Other1">
<div class="title-block exclude-auto" id="title-block5"><a id="pagebreak-rw_1">
</a><h1 id="h16"><a id="pagebreak-rw_1"></a><a href="#/9781783784370_tableofcontents">THIS GOLDEN FLEECE</a></h1>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781783784370_other_01.vue?9b95cb58